import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import { FormTxtArea } from 'atoms/Inputs'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
} from './styles'

export class SendBackRemarkModal extends PureComponent {

  render() {
    const { theme, sendBackRemarkData, fnChange } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            Add Remark
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <div className={'row col-12 mx-0 px-0'}>
            <Label lineheight={'14px'} size={'12px'}>
              Remark
            </Label>
            <FormTxtArea
              placeholder={'Enter remark'}
              rows="5"
              mb={'16px'}
              onChangeVal={e => fnChange(e.target.value)}
              value={sendBackRemarkData.remark}
              {...inputConfig}
            />
          </div>
        </LevelRowContainer>

        <ModalFooter>
          <ButtonReg
            onClick={this.props.fnSwitch}
            transparent
            bg={theme.unreadRed}
            color={theme.unreadRed}
            bordered
            btnTxt={'Cancel'}
            margin={'0 16px 0 0'}
          />
          <ButtonReg
            onClick={this.props.fnSubmit}
            background={'linear-gradient(90deg, #463191 0%, #C802FF 90.26%)'}
            btnTxt={'Submit'}
          />
        </ModalFooter>

      </MainWrapper>
    )
  }
}

export default withTheme(SendBackRemarkModal)
